export default {
    user: {},
    userData: {
        nomeFuncionario: '',
    },
    token: ''
}